module.exports = __webpack_public_path__ + "43b45e97733773f7f146b6f6fadba85b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_add_image.svg
// module id = 90
// module chunks = 0